namespace $.$$ {
	export class $eve_app_page_components_empty extends $.$eve_app_page_components_empty {}
}
